import FreeHomeValuation from 'containers/free-home-valuation';

function FreeHomeValuationPage() {
  return <FreeHomeValuation />;
}

export default FreeHomeValuationPage;
